/**
 * Always-shippable debug overlay (?debug=1, or on by default in dev).
 * "Emergence you can't see, you can't tune."
 */
export class DebugOverlay {
  private readonly el: HTMLDivElement;
  private lastRender = 0;
  private fpsEma = 0;
  private frameMsEma = 0;

  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.style.cssText = [
      'position:fixed',
      'top:4px',
      'left:4px',
      'padding:4px 6px',
      'background:rgba(0,0,0,0.55)',
      'color:#33FF66',
      'font:10px/1.5 Consolas,monospace',
      'white-space:pre',
      'pointer-events:none',
      'z-index:100',
    ].join(';');
    parent.appendChild(this.el);
  }

  frame(dt: number): void {
    const fps = 1 / Math.max(1e-4, dt);
    this.fpsEma = this.fpsEma === 0 ? fps : this.fpsEma * 0.95 + fps * 0.05;
    this.frameMsEma = this.frameMsEma * 0.95 + dt * 1000 * 0.05;
  }

  update(fields: Record<string, string | number>): void {
    const now = performance.now();
    if (now - this.lastRender < 250) return;
    this.lastRender = now;
    const lines = [
      `fps ${this.fpsEma.toFixed(0)}  ${this.frameMsEma.toFixed(1)}ms`,
    ];
    for (const [k, v] of Object.entries(fields)) {
      lines.push(`${k} ${typeof v === 'number' ? +v.toFixed(2) : v}`);
    }
    this.el.textContent = lines.join('\n');
  }
}
